import { Button } from '@shared/components/ui/button';
import { usePermissions } from '@shared/hooks/usePermissions';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

// interface CreateClientButtonProps {
//   /** Si true, aplica estilos para estar dentro de EmptyView */
//   inline?: boolean;
// }

/**
 * Componente para el botón de crear cliente
 * Maneja la navegación y permisos de creación
 * Puede usarse arriba (con posicionamiento) o dentro de EmptyView
 */
export const CreateClientButton = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('clientsModule');
  const { canAccess } = usePermissions();

  // Verificar si el usuario puede crear clientes
  const canCreate = canAccess(['tenant_3pl'], ['iam.teams.create-child']);

  // Si no tiene permisos, no mostrar el botón
  if (!canCreate) {
    return null;
  }

  return (
    <Button
      variant="primary"
      size="default"
      onClick={() => navigate('/clients/create')}
      data-testid="create-client-button"
    >
      {t('buttons.create')}
    </Button>
  );
};
